<template>
  <div class="card">
    <loading
      :active.sync="customerLoading"
      :can-cancel="true"
      :is-full-page="true"
    >
    </loading>
    <div class="card-body">
      <h5 class="card-title text-muted">
        <strong> {{ $t("customer.selectCustomer") }}</strong>
      </h5>
      <hr />
      <search :term="searchTerm" @search="setSearchTerm" />
      <h6 class="float-right">
        {{ $t("customer.counter") }} {{ processedCustomersTotal }}
      </h6>
      <div class="form-group container-fluid p-0">
        <div class="col-md-12 p-0">
          <div class="row">
            <!-- <div class="col-md-12 p-0">
              <label class="mr-2" for="onlyMe">
                {{ $t("common.onlyMe") }}
              </label>
              <input
                id="onlyMe"
                type="checkbox"
                @change="setSlpCode($event.target)"
              />
            </div> -->
            <div class="col-md-6 p-0">
              <label for="countryFilter">
                {{ $t("common.selectCountry") }}
              </label>
              <select
                id="countryFilter"
                class="form-control"
                :value="searchCountry"
                @change="setSearchCountry($event.target.value)"
              >
                <option
                  v-for="country in countries"
                  :key="country.name"
                  :value="country.code"
                >
                  {{ locale === "pl" ? country.namepl : country.nameen }}
                </option>
              </select>
            </div>
            <div v-show="searchCountry == 'PL'" class="col-md-6">
              <label for="province">
                {{ $t("common.selectProvince") }}
              </label>
              <select
                id="province"
                class="form-control"
                :value="searchProvince"
                @change="setSearchProvince($event.target.value)"
              >
                <option
                  v-for="state in this.province"
                  :key="state.name"
                  :value="state.code"
                >
                  {{ state.name }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table class="table table-bordered table-striped p-2">
          <thead>
            <tr>
              <th scope="col">
                {{ $t("customer.codeBp") }}
              </th>
              <th scope="col">
                {{ $t("customer.name") }}
              </th>
              <th scope="col">
                {{ $t("customer.vatNumber") }}
              </th>
              <th scope="col">
                {{ $t("customer.billingAddress") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="customer in processedCustomers"
              :key="customer['customerId']"
              class="m-1 p-1"
              :class="{ 'bg-warning': false }"
            >
              <td class="text-center">
                <h6>{{ customer.cardCode }}</h6>
              </td>
              <td class="text-center">
                <h6>{{ customer.company }}</h6>
              </td>
              <td>{{ customer.vat }}</td>
              <td>
                {{ customer.addressInformation }}
              </td>
              <td colspan="3" class="">
                <button
                  class="btn btn-success btn-sm text-center"
                  @click="handleSelectCustomer(customer)"
                >
                  {{ $t("buttons.select") }}
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <page-controls
          :number-of-pages="customerPageCount"
          :current-page="currentPage"
          @pageChange="setCurrentPage"
          @sizeChange="setPageSize"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import Search from "./Search";
import PageControls from "./PageControls";
import { StateList } from "../enums/State";
import { CountryListGus } from "../enums/CountriesAll";
import i18n from "../translations";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import * as ServiceGeneric from "../services/generic";
import Vue from "vue";

export default {
  name: "CustomerList",
  components: { Search, PageControls, Loading },
  filters: {
    currency(value) {
      return new Intl.NumberFormat("pl-PL", {
        style: "currency",
        currency: "PLN",
      }).format(value);
    },
  },
  data() {
    return {
      locale: i18n.locale,
      province: StateList,
      countries: CountryListGus,
      isLoading: false,
      fullPage: true,
    };
  },

  mounted() {
    this.setCurrentCountry();
    this.setCurrentProvince();
    this.setCurrentUser();
    this.setCountries();
    this.getNotifications();
  },
  computed: {
    ...mapGetters("customers", [
      "processedCustomers",
      "processedCustomersTotal",
      "customersFilteredBySalesPerson",
      "customersFilterByProvince",
      "customerPageCount",
      "customerLoading",
    ]),
    ...mapGetters("auth", ["availableCountries"]),
    ...mapState("customers", [
      "searchTerm",
      "currentPage",
      "searchProvince",
      "searchCountry",
    ]),
    ...mapState("auth", ["user", "availableCountries"]),
  },
  methods: {
    ...mapMutations("customers", [
      "setSearchTerm",
      "setSearchProvince",
      "setSearchCountry",
      "setCurrentPage",
      "setPageSize",
      "setCurrentProvince",
      "setCurrentCountry",
      "setSlpCode",
    ]),
    async getNotifications() {
      let userId = this.user.ownerCode;
      let response = await ServiceGeneric.getNotifications(userId);
      if (response.data) {
        console.log(response.data);
        response.data.reportFormSubmit.allReports.forEach((element) => {
          if (element.message == "prepareInvoiceWithTransport") {
            Vue.alert(
              "Należy wygenerować fakturę ze ZS na kontrahencie " +
                element.debt +
                " " +
                element.base64,
              "Faktura do realizacji z transportem",
              "warning"
            );
          } else if (element.message == "OK") {
          }
        });
      } else {
        console.log(response);
      }
      return response.data.reportFormSubmit.allReports;
    },
    setCountries() {
      const filterByReference = (arr1, arr2) => {
        let res = [];
        res = arr1.filter((el) => {
          return arr2.find((element) => {
            return element.countryCode === el.code;
          });
        });
        return res;
      };
      let countryList = filterByReference(
        CountryListGus,
        this.availableCountries
      );
      this.countries = countryList;
    },
    setCurrentProvince() {
      this.setSearchProvince("00");
    },
    setCurrentCountry() {
      if (this.user.dept === "5") {
        this.setSearchCountry("PL");
      } else {
        this.setSearchCountry("00");
      }
    },
    setCurrentUser() {
      let slpCode = this.user.slpCode;
      this.setSlpCode(slpCode);
      this.processedCustomers;
    },
    handleSelectCustomer(customer) {
      this.$store.commit("cart/setCleanCart", []);
      this.$store.commit("cart/selectCustomer", customer);
      this.$store.commit("cart/setCartData", []);
      localStorage.removeItem("cart");
      this.$router.push({
        name: "customer",
        params: {
          id: customer.customerId,
        },
      });
    },
    handleFilteredUser(customer) {},
  },
};
</script>
